import React, { PureComponent, Fragment } from 'react';

import withSlide from '~/kits/general/scripts/components/withSlide';
import ComparisonMap from '~/kits/general/scripts/components/ComparisonMap';
import { getColorScale } from '~/kits/general/scripts/components/ComparisonMap/utils';
import { getMapDataByKey, getDonutDataByKey } from '~/kits/general/scripts/data-utils';

const colorScale = getColorScale([
  [0, '#ffff70'],
  [9, '#feed5b'],
  [19, '#fcdd45'],
  [28, '#facc2c'],
  [37, '#f6bb00']
]);

const mapData = getMapDataByKey('lib');
const donutData = getDonutDataByKey('lib', '#F6BB00');
const maxLegendValue = 36;

class LiberalMap extends PureComponent {
  render() {
    const { title, text, isActive } = this.props;

    return (
      <ComparisonMap
        title={title}
        text={text}
        isActive={isActive}
        mapData={mapData}
        colorScale={colorScale}
        donutData={donutData}
        maxLegendValue={maxLegendValue}
      />
    );
  }
}

export default withSlide(LiberalMap);
